require("./data-grid-display.scss");